import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function PricingTable() {
  const [selected, setSelected] = useState<'pro' | 'acelerador'>('acelerador');
  return <section id="pricing" className="py-16 px-4 pt-[25px] pb-[25px]" data-id="element-214">
      <div className="max-w-lg mx-auto" data-id="element-215">
        <div className="text-center mb-8" data-id="element-216">
          <h2 className="text-3xl md:text-4xl font-black mb-1" data-id="element-217">
            ELEGÍ TU <span className="text-brand" data-id="element-218">ULTRAPACK</span>
          </h2>
        </div>

        <div className="flex flex-col gap-5" data-id="element-219">
          {/* Plan 1 — ULTRAPACK ESTÁNDAR */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('pro')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'pro' ? 'border-2 border-brand shadow-[0_0_30px_rgba(249,115,22,0.15)]' : 'border border-dark-border'}`} data-id="element-220">
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-221">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'pro' ? 'border-brand' : 'border-gray-600'}`} data-id="element-222">
                {selected === 'pro' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-223" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-224">
              <div className="flex items-start justify-between gap-3" data-id="element-225">
                <div data-id="element-226">
                  <div className="mb-1 text-[18px]" data-id="element-227">📘</div>
                  <h3 className="font-bold text-[14px]" data-id="element-228">ULTRAPACK ESTÁNDAR</h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-229">
                    6 Tomos + 6 Bonos
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-230">
                  <div className="text-gray-500 line-through text-xs" data-id="element-231">
                    $51.000
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-white leading-tight" data-id="element-232">
                    $19.990
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-233">
                Ideal para: Empezar hoy desde casa con lo que tenés.
              </p>
            </div>
          </motion.button>

          {/* Plan 2 — ULTRAPACK + MÉTODO BOUTIQUE */}
          <motion.button type="button" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelected('acelerador')} className={`relative text-left bg-dark-card rounded-2xl p-5 flex items-start gap-4 transition-all cursor-pointer ${selected === 'acelerador' ? 'border-2 border-brand shadow-[0_0_30px_rgba(249,115,22,0.15)]' : 'border border-dark-border'}`} data-id="element-234">
            {/* Radio */}
            <div className="mt-1 flex-shrink-0" data-id="element-235">
              <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'acelerador' ? 'border-brand' : 'border-gray-600'}`} data-id="element-236">
                {selected === 'acelerador' && <div className="w-2.5 h-2.5 rounded-full bg-brand" data-id="element-237" />}
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-238">
              <div className="flex items-start justify-between gap-3" data-id="element-239">
                <div data-id="element-240">
                  <div className="text-xl mb-1" data-id="element-241">🏆</div>
                  <h3 className="font-bold text-[14px]" data-id="element-242">
                    ULTRAPACK + MÉTODO BOUTIQUE ⭐
                  </h3>
                  <p className="text-gray-400 mt-1 text-[12px]" data-id="element-243">
                    6 Tomos + 6 Bonos + Ebook Upsell "Contratos Corporativos"
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-244">
                  <div className="text-gray-500 line-through text-xs" data-id="element-245">
                    $69.000
                  </div>
                  <div className="text-2xl md:text-3xl font-black text-brand leading-tight" data-id="element-246">
                    $27.990
                  </div>
                </div>
              </div>
              <p className="text-brand font-bold mt-3 text-[10px]" data-id="element-247">
                Ideal para: Personas que quieran ir de 0 a 100 hoy mismo.
              </p>
            </div>
          </motion.button>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="mt-6" data-id="element-248">
          <a href={selected === 'acelerador' ? 'https://ultrapack.digital/cart/47722956030126:1' : 'https://ultrapack.digital/cart/47722955341998:1'} target="_blank" rel="noopener noreferrer" className="w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(249,115,22,0.4)] text-[16px]" data-id="element-249">
            {selected === 'acelerador' ? '→ QUIERO EL ULTRAPACK + MÉTODO BOUTIQUE' : '→ QUIERO EL ULTRAPACK ESTÁNDAR'}
          </a>
        </motion.div>
      </div>
    </section>;
}